import React, { useState } from "react";
import { IconButton, InputAdornment, TextField, Tooltip } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { UseFormRegisterReturn } from "react-hook-form";

export type PasswordFieldProps = {
  label: string;
  registration: UseFormRegisterReturn;
  error?: string;
  disabled?: boolean;
};

export const PasswordField: React.FC<PasswordFieldProps> = ({
  label,
  registration,
  error,
  disabled,
}) => {
  const [showSecret, setShowSecret] = useState(false);

  return (
    <TextField
      label={label}
      required
      fullWidth
      autoComplete="off"
      type={showSecret ? "text" : "password"}
      disabled={disabled}
      {...registration}
      error={!!error}
      helperText={error ?? ""}
      slotProps={{
        input: {
          endAdornment: (
            <InputAdornment position="end">
              <Tooltip title={showSecret ? "Hide" : "Show"}>
                <IconButton
                  onClick={() => setShowSecret((p) => !p)}
                  edge="end"
                  disabled={disabled}
                  aria-label={showSecret ? "Hide password" : "Show password"}
                >
                  {showSecret ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ),
        },
      }}
    />
  );
};
